import { AppConfig } from '../types/appConfig';

let appConfig: AppConfig = {
  i18nApiUrl: '',
  apiUrl: '',
  aadClientId: '',
};

export function setAppConfig(newAppConfig: AppConfig): void {
  appConfig = newAppConfig;
}

export function getAppConfig(): AppConfig {
  return appConfig;
}
